import { render } from "./ResetPasswordPage.vue?vue&type=template&id=191cd55e&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__